import React, { useEffect, useState } from "react";

import Dropdown from "components/Dropdown";

import { TagColorOptions } from "../../../constants/chartConstant";

const ChartTagColorRenderer = props => {
  const [color, setColor] = useState(props.node.data.Color);
  const [availableColors, setAvailableColors] = useState([]);

  useEffect(() => {
    const colors = props.getAvailableColors();
    setAvailableColors(colors);
  }, []);

  const changeHandler = value => {
    if (value) {
      const Color = value.code;
      setColor(Color);
      props.node.setData({ ...props.node.data, Color, isEdited: true });
      props.context.updateChartView("Color");
    }
  };

  const getColorCode = colorName => {
    const color = TagColorOptions.find(color => color.name === colorName);
    return color?.code;
  };

  const getValue = () => TagColorOptions.find(colorItem => colorItem.code === color);

  const inputAdornment = value => ({
    startAdornment: (
      <span
        className="chart-edit-tag-input-icon"
        style={{
          backgroundColor: getColorCode(value),
          marginLeft: "10px"
        }}
      />
    )
  });

  const renderOption = option => (
    <>
      <span className="chart-edit-tag-input-icon" style={{ backgroundColor: option.code }} />
      {option.name}
    </>
  );

  return (
    <Dropdown
      value={getValue()}
      options={availableColors}
      getOptionLabel={option => option.name}
      onChange={changeHandler}
      renderOption={renderOption}
      inputAdornment={inputAdornment}
      customClass="chart-tag-drop-down"
    />
  );
};

export default ChartTagColorRenderer;
